/**
 * Datos centrales editables de Katia Falón Odontología.
 * Todo aquí es la ÚNICA fuente de verdad para nombre, contacto, WhatsApp, Maps, etc.
 * Cuando falte información, la variable queda en cadena vacía y la UI la oculta.
 */
export const CLINIC = {
  name: "Katia Falón Odontología",
  legalName: "Katia Falón Odontología",
  tagline: "Odontología sin dolor en el corazón de Armenia, con atención cercana para adultos y niños.",
  address: "Cra. 14 #17N-32, Armenia, Quindío, Colombia",
  city: "Armenia",
  region: "Quindío",
  country: "Colombia",
  phone: "+573113009975",
  phoneDisplay: "(+57) 311 300 9975",
  email: "info@katiafalonodontologia.com",
  // Correo dedicado para PQRS. Cuando la clínica lo defina, cambia esta línea.
  managementEmail: "", // ← [CORREO_GERENCIA] pendiente de asignación
  instagram: "https://www.instagram.com/katiafalonodontologia",
  instagramHandle: "@katiafalonodontologia",
  // WhatsApp con mensaje inicial predefinido
  whatsappMessage: "Hola, quiero solicitar información sobre una cita de valoración.",
  // Ubicaciones externas (Google)
  mapsQuery: "Katia+Falón+Odontología,+Cra.+14+%2317N-32,+Armenia,+Quindío,+Colombia",
  mapsDirectionsUrl: "https://www.google.com/maps/dir/?api=1&destination=Katia+Falón+Odontología+Armenia+Quindío",
  // Enlace público al perfil de Google Business (opcional — actualizar cuando esté disponible)
  googleReviewsUrl: "",
  hours: [
    { day: "Lunes a viernes", hours: "8:00 a. m. a 6:00 p. m." },
    { day: "Sábados", hours: "8:00 a. m. a 1:30 p. m." },
    { day: "Domingos", hours: "Cerrado" },
  ],
  // Convenios disponibles. Cuando la clínica los defina, añádelos aquí.
  agreements: [], // ← [CONVENIOS] pendientes
};

// URL de WhatsApp con mensaje inicial (formato compatible móvil + escritorio)
export const WHATSAPP_URL = `https://wa.me/${CLINIC.phone.replace("+", "")}?text=${encodeURIComponent(CLINIC.whatsappMessage)}`;

// Tipos de cita disponibles para reserva ONLINE.
// Otros tratamientos requieren valoración previa y no se agendan directamente.
export const APPOINTMENT_TYPES = [
  {
    slug: "valoracion-adulto",
    label: "Valoración para adulto",
    description: "Primera consulta con la Dra. Katia Falón. Revisamos tu caso y te explicamos las opciones antes de iniciar cualquier tratamiento.",
    duration: 30,
  },
  {
    slug: "valoracion-odontopediatria",
    label: "Valoración de odontopediatría",
    description: "Consulta pensada para niños y adolescentes. Ambiente amable y explicaciones adaptadas a su edad.",
    duration: 30,
  },
  {
    slug: "higiene-oral",
    label: "Higiene oral",
    description: "Profilaxis y limpieza dental profesional. Ideal para mantener la salud bucal.",
    duration: 45,
  },
];
